'use strict';
angular.module('getFileMD5ServiceModule', []).factory('getFileMD5Service', ['$q', 'modalDialog',
    function($q, modalDialog) {
        // 存储md5构造函数
        var spark = '';
        // 文件分片，兼容
        var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;

        /**
         * [doIncrementalTest description] 转换md5
         * @param   {[type]}  file      [file description] 文件对象
         * @return  {[type]}            [return description]
         */
        function doIncrementalTest(file) {
            var defer = $q.defer();
            var chunkSize = 2097152; // read in chunks of 2MB
            var chunks = Math.ceil(file.size / chunkSize);
            var running = true;
            var currentChunk = 0;
            var fileReader = new FileReader();
            fileReader.onload = function (e) {
                spark.appendBinary(e.target.result);
                currentChunk += 1;

                if (currentChunk < chunks) {
                    loadNext();
                } else {
                    running = false; 
                    defer.resolve(spark.end());
                }
            };

            fileReader.onerror = function () {
                running = false;
                defer.reject();
            };

            running = true;
            loadNext();
        
            /**
             * [loadNext description] 文件分片转换md5
             * @return  {[type]}  [return description]
             */
            function loadNext() {
                var start = currentChunk * chunkSize,
                    end = start + chunkSize >= file.size ? file.size : start + chunkSize;

                fileReader.readAsBinaryString(blobSlice.call(file, start, end));
            }
            return defer.promise;
        }
        return {

            /**
             * [init description] 初始化md5
             * @return  {[type]}  [return description]
             */
            init: function() {
                require(['./lib/js-spark-md5-master/spark-md5.min', ], function(SparkMD5) {
                    spark = new SparkMD5();
                });
            },

            /**
             * [getMd5 description] 文件转换md5
             * @param   {[type]}  file  [file description] 文件对象
             * @return  {[type]}        [return description]
             */
            getMd5: function(file) {
                var defer = $q.defer();
                doIncrementalTest(file).then(function(data) {
                    defer.resolve(data);
                }, function() {
                    modalDialog.alertType('', '获取文件md5值失败', 'info', false);
                    defer.reject();
                });
                return defer.promise;
            },
        };
    },
]);
